<template>
    <div v-if="parseInt(minbid) <= parseInt(highBid)" class="checkedYes"><a href="/seite/agb#mindestgebot" target="_blank">Mindestgebot</a>:</div>
    <div v-else class="checkedNo"><a href="/seite/agb#mindestgebot" target="_blank">Mindestgebot</a>:</div>
</template>

<script>

    export default {
        props: {
            pid: {
                type: [String, Number],
                required: true,
                default: null
            },
            higestbid: {
                type: [String, Number],
                required: true,
                default: 0
            },
            minbid: {
                type: [Number,String],
                default: ''
            }
        },

        data () { 
            return {
               highBid: 0
            }
        },

        mounted: function() {
            App.socket.on('12meins-channel:App\\Events\\UserBid', (data) => {
                if(this.pid == data.productId) {
                    this.highBid = data.bid;
                    if(data.uid == this.uid) {
                        this.userBid = data.bid;
                    }
                }  
            });
        },

        created () {
            this.highBid = this.higestbid;
        }
    }
</script>
